import type { DocumentModel } from 'shared/domain/document/documentModel';
import { DomainMessagesTypes } from 'shared/domain/messages/message';

/**
 * Whether a newly read list differs from the shown one in what the views
 * display (identity, sync, conversion), so equal reads keep the same array.
 */
export function hasDocumentListChanged(
  nextDocuments: DocumentModel[],
  shownDocuments: DocumentModel[]
): boolean {
  if (nextDocuments.length !== shownDocuments.length) {
    return true;
  }

  const shownByLocalId = new Map(shownDocuments.map((document) => [document.localId, document]));
  return nextDocuments.some((next) => {
    const shown = shownByLocalId.get(next.localId);
    return (
      !shown ||
      shown.modifiedAt !== next.modifiedAt ||
      shown._id !== next._id ||
      shown.syncStatus !== next.syncStatus ||
      shown.deleted !== next.deleted ||
      shown.imageConvertStatus !== next.imageConvertStatus
    );
  });
}

/** Document changes after which the open lists are read again. */
export function shouldReloadDocumentsAfter(event: { type: DomainMessagesTypes }): boolean {
  return (
    event.type === DomainMessagesTypes.updatedEntity ||
    event.type === DomainMessagesTypes.deletedEntity
  );
}

/** A scope shows a spinner until its first read ends, unless it already shows documents. */
export function isDocumentScopeLoading(
  loading: boolean | undefined,
  documents: DocumentModel[] | undefined
): boolean {
  return loading ?? !documents?.length;
}
